function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1040",
  "data-name": "Group 1040",
  transform: "translate(-21.463 -200.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1004",
  "data-name": "Group 1004",
  transform: "translate(19.713 265.145)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_589",
  "data-name": "Path 589",
  d: "M25.373-57.856a1,1,0,0,0-.294-.71,1,1,0,0,0-.71-.294H8.74a1.008,1.008,0,0,0-.712.3,1.008,1.008,0,0,0-.3.712v18.038H25.373Z",
  transform: "translate(-3.639 -3.508)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_590",
  "data-name": "Path 590",
  d: "M16.451-46.4H28.23v-3.769H16.451Z",
  transform: "translate(-9.427 -9.28)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M26.138-18.105H31.4v-7.631H26.138Z",
  transform: "translate(-15.858 -25.497)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_592",
  "data-name": "Path 592",
  d: "M2.25-2.25H23.4",
  transform: "translate(0 -41.088)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M18.456-64.144H28.71",
  transform: "translate(-10.758)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1002",
  "data-name": "Group 1002",
  transform: "translate(-51 -276)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_910",
  "data-name": "Group 910",
  transform: "translate(89 487.592)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_486",
  "data-name": "Path 486",
  d: "M222.024-169.847a1.5,1.5,0,0,0-1.608-1.371h-6.783a1.5,1.5,0,0,0-1.608,1.371v8.772a1.5,1.5,0,0,0,1.608,1.371h6.783a1.5,1.5,0,0,0,1.608-1.371Z",
  transform: "translate(-212.024 172.79)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-176.9H227v-1.547h-6.176Z",
  transform: "translate(-218.907 178.45)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-116.419H227v-.387h-6.176Z",
  transform: "translate(-218.907 130.115)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h9.938",
  transform: "translate(-212.137 165.703)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "bottle",
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h9.938",
  transform: "translate(-212.137 138.306)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_747",
  "data-name": "Path 747",
  d: "M228.8-149.994a8,8,0,0,1,1.087,2.272,1.087,1.087,0,0,1-1.087,1.087,1.087,1.087,0,0,1-1.087-1.087A8,8,0,0,1,228.8-149.994Z",
  transform: "translate(-134.796 643.337)",
  fill: "#48b05e",
  fillRule: "evenodd"
})));

var SvgCompanyStock = function SvgCompanyStock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.912,
    height: 25.162,
    viewBox: "0 0 26.912 25.162",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyStock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company-stock.d09fcb58.svg";
export { ForwardRef as ReactComponent };